export default __webpack_public_path__ + "static/woori_asset_trust-8f978bc4ec473aba698d3c40b0f4da8f.png";